import { render, staticRenderFns } from "./apiproductreport.vue?vue&type=template&id=5518c12a&"
import script from "./apiproductreport.vue?vue&type=script&lang=js&"
export * from "./apiproductreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports